import React, { CSSProperties } from 'react'
import Avatar, { ugcUserLink, IProps as IAvatarProps } from './avatar'
import { stopPropagation } from 'Components/new/community-card/interact'

export interface IProps extends IAvatarProps {
  onClick?: () => void
  textColor?: string
  style?: CSSProperties
}

const AuthorAvatar: React.FC<IProps> = ({
  onClick,
  textColor = '#1f2129',
  style,
  userId,
  username,
  userVerified,
  verifyType,
  avatar,
}) => {
  return (
    <div className="avatar-wrap" style={style}>
      <Avatar
        onClick={onClick}
        userId={userId}
        username={username}
        userVerified={userVerified}
        verifyType={verifyType}
        avatar={avatar}
      />
      {username ? (
        <p
          className="name line-1"
          onClick={stopPropagation(onClick)}
          title={username}
        >
          {ugcUserLink({ userId })(username)}
        </p>
      ) : null}
      <style jsx>
        {`
          .avatar-wrap {
            width: 100%;
            position: absolute;
            bottom: -25px;
            left: 0;
            padding-left: 10px;
            padding-right: 8px;
            display: flex;
            align-items: flex-end;
          }
          .avatar-wrap :global(.name) {
            flex: 1;
            display: block;
            font-size: 14px;
            line-height: 14px;
            font-weight: 500;
            color: ${textColor};
            margin-left: 8px;
          }
        `}
      </style>
    </div>
  )
}

export default AuthorAvatar
